"use client";

import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import { cn } from "../lib/utils";

const ColorPiker = ({ value, onChange, direction }: any) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState({
    r: parseInt(value.slice(1, 3), 16),
    g: parseInt(value.slice(3, 5), 16),
    b: parseInt(value.slice(5, 7), 16),
    a: 1,
  });

  useEffect(() => {
    setColor({
      r: parseInt(value.slice(1, 3), 16),
      g: parseInt(value.slice(3, 5), 16),
      b: parseInt(value.slice(5, 7), 16),
      a: 1,
    });
    console.log(value);
  }, [value]);

  const handleClick = () => setDisplayColorPicker(!displayColorPicker);
  const handleClose = () => setDisplayColorPicker(false);

  const handleChange = (newColor: any) => {
    setColor(newColor.rgb);
    if (onChange) {
      const hex = `#${(
        (1 << 24) +
        (newColor.rgb.r << 16) +
        (newColor.rgb.g << 8) +
        newColor.rgb.b
      )
        .toString(16)
        .slice(1)}`;
      onChange(hex);
    }
  };

  return (
    <div className="relative w-full">
      <div
        className="h-10 p-2 backdrop-blur-xl bg-white/5 border border-white/10 cursor-pointer w-full rounded-md"
        onClick={handleClick}
        style={{ touchAction: 'manipulation' }}
      >
        <div
          className="h-full rounded-sm border border-white/20"
          style={{
            background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
          }}
        />
      </div>

      {displayColorPicker && (
        <div
          className={cn(
            "absolute z-50 mt-1",
            direction == "left" ? "left-0" : "right-0",
          )}
          style={{ touchAction: 'manipulation' }}
        >
          <div 
            className="fixed inset-0" 
            onClick={handleClose}
            style={{ touchAction: 'manipulation' }}
          />
          <div style={{ touchAction: 'manipulation' }}>
            <SketchPicker
              color={color}
              onChange={handleChange}
              disableAlpha
              width="15rem"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPiker;
